import React from "react";
import GestureButton from "./GestureButton";
import { Action } from "../karaoke/actions";

export default function PauseControl({ activeAction, onTrigger, className }) {
  return (
    <GestureButton
      action={Action.PAUSE}
      label="Pause"
      emoji="✊"
      activeAction={activeAction}
      onTrigger={onTrigger}
      className={className}
    />
  );
}
